const sections = [
  {
    title: '1. Quem somos',
    content: `MyBank Tecnologia Ltda., inscrita no CNPJ 00.000.000/0001-00, com sede em São Paulo/SP, é a controladora dos dados pessoais tratados por meio da plataforma MyBank (site e aplicativo web). Nosso encarregado de dados (DPO) pode ser contatado em privacidade@mybank.com.br.`,
  },
  {
    title: '2. Quais dados coletamos',
    content: `Coletamos apenas os dados estritamente necessários para a prestação do serviço:

**Dados de cadastro:** nome, endereço de e-mail e senha (armazenada com hash bcrypt).

**Dados financeiros:** transações, contas, categorias e metas que você cadastra manualmente na plataforma. Não coletamos dados bancários, não acessamos suas contas bancárias e não nos conectamos a Open Finance.

**Dados de uso:** logs de acesso (IP, data/hora, ações realizadas) para segurança e diagnóstico de problemas.

**Dados de pagamento:** processados integralmente pelo Stripe. Não armazenamos dados de cartão de crédito.

**Cookies:** utilizamos cookies essenciais para autenticação e cookies de análise (sem identificação pessoal) para melhorar a experiência.`,
  },
  {
    title: '3. Para que usamos os dados',
    content: `Usamos seus dados exclusivamente para:

- Prestar e melhorar os serviços do MyBank
- Enviar notificações e alertas que você configurou
- Enviar comunicações transacionais (confirmação de cadastro, redefinição de senha)
- Enviar comunicações de marketing, se você optou por recebê-las (opt-in)
- Cumprir obrigações legais
- Segurança e prevenção a fraudes

**Nunca** vendemos, alugamos ou compartilhamos seus dados pessoais com terceiros para fins publicitários.`,
  },
  {
    title: '4. Base legal para o tratamento',
    content: `Tratamos seus dados com base nas seguintes hipóteses legais da LGPD (Lei 13.709/2018):

- **Execução de contrato:** para prestar o serviço contratado
- **Legítimo interesse:** para segurança e melhoria do produto
- **Cumprimento de obrigação legal:** quando exigido por lei
- **Consentimento:** para comunicações de marketing (você pode revogar a qualquer momento)`,
  },
  {
    title: '5. Compartilhamento de dados',
    content: `Compartilhamos dados apenas com os seguintes parceiros e somente na extensão necessária:

- **Stripe:** processamento de pagamentos
- **Amazon Web Services (AWS):** infraestrutura de nuvem (servidores no Brasil)
- **Autoridades públicas:** quando exigido por determinação judicial ou legal

Todos os nossos parceiros estão vinculados a acordos de processamento de dados e comprometidos com a proteção das informações.`,
  },
  {
    title: '6. Segurança dos dados',
    content: `Adotamos medidas técnicas e organizacionais para proteger seus dados:

- Criptografia em trânsito: TLS (via AWS API Gateway)
- Criptografia em repouso: AES-256 (via AWS DynamoDB)
- Autenticação em dois fatores (2FA) disponível
- Infraestrutura hospedada na AWS com certificações SOC 2 e ISO 27001

Em caso de incidente de segurança que afete seus dados, notificaremos a ANPD e os titulares afetados no prazo legal.`,
  },
  {
    title: '7. Retenção de dados',
    content: `Mantemos seus dados enquanto você tiver uma conta ativa no MyBank. Após o encerramento da conta:

- Dados de transações e conta: excluídos em até 30 dias
- Logs de segurança: retidos por até 6 meses conforme exigência legal
- Dados de faturamento: retidos por 5 anos conforme legislação fiscal

Você pode solicitar a exclusão imediata dos seus dados pessoais a qualquer momento nas configurações da conta ou por e-mail.`,
  },
  {
    title: '8. Seus direitos',
    content: `Conforme a LGPD, você tem direito a:

- **Confirmação:** saber se tratamos seus dados
- **Acesso:** obter cópia dos dados que mantemos
- **Correção:** corrigir dados incompletos ou inexatos
- **Anonimização ou exclusão:** remover dados desnecessários
- **Portabilidade:** receber seus dados em formato estruturado
- **Revogação do consentimento:** a qualquer momento
- **Oposição:** contestar tratamentos baseados em legítimo interesse

Para exercer qualquer direito, acesse as Configurações > Dados ou envie e-mail para privacidade@mybank.com.br. Respondemos em até 15 dias úteis.`,
  },
  {
    title: '9. Cookies',
    content: `Utilizamos os seguintes tipos de cookies:

**Essenciais:** necessários para autenticação e segurança. Não podem ser desativados.

**Analíticos:** coletamos dados agregados de uso (páginas visitadas, tempo de sessão) para melhorar o produto. Não identificam você individualmente. Você pode recusá-los.

Você pode gerenciar cookies nas configurações do seu navegador. A recusa de cookies analíticos não afeta o funcionamento do produto.`,
  },
  {
    title: '10. Alterações nesta política',
    content: `Podemos atualizar esta política periodicamente. Notificaremos sobre alterações relevantes por e-mail com antecedência mínima de 15 dias. O uso continuado do serviço após esse prazo implica concordância com a nova política.`,
  },
  {
    title: '11. Contato',
    content: `Para dúvidas sobre privacidade ou para exercer seus direitos:

**E-mail:** privacidade@mybank.com.br
**Endereço:** Av. Brigadeiro Faria Lima, 1234 — São Paulo/SP — CEP 01451-001
**DPO:** disponível em privacidade@mybank.com.br`,
  },
];

const renderContent = (content) =>
  content.split('\n\n').map((block, i) => {
    if (!block.trim()) return null;
    const lines = block.split('\n');
    const isListBlock = lines.some((l) => l.startsWith('- '));

    if (isListBlock) {
      return (
        <ul key={i} className="list-disc list-inside space-y-1 my-3 text-gray-600 dark:text-gray-400 text-sm leading-relaxed">
          {lines.filter((l) => l.startsWith('- ')).map((l, j) => (
            <li key={j} dangerouslySetInnerHTML={{ __html: l.slice(2).replace(/\*\*(.*?)\*\*/g, '<strong class="text-gray-900 dark:text-white">$1</strong>') }} />
          ))}
        </ul>
      );
    }

    return (
      <p key={i} className="text-gray-600 dark:text-gray-400 text-sm leading-relaxed mb-3"
        dangerouslySetInnerHTML={{ __html: block.replace(/\*\*(.*?)\*\*/g, '<strong class="text-gray-900 dark:text-white">$1</strong>') }} />
    );
  });

const PrivacyContent = () => (
  <div className="space-y-8">
    <div className="bg-primary-50 dark:bg-primary-900/20 border border-primary-200 dark:border-primary-800 rounded-xl p-5">
      <p className="text-primary-800 dark:text-primary-200 font-semibold mb-2">Nosso compromisso em linguagem simples:</p>
      <ul className="space-y-1 text-primary-700 dark:text-primary-300 text-sm">
        <li>✅ Seus dados financeiros são seus. Sempre.</li>
        <li>✅ Nunca vendemos seus dados para anunciantes.</li>
        <li>✅ Você pode excluir tudo a qualquer momento.</li>
        <li>✅ Não acessamos sua conta bancária. Jamais.</li>
      </ul>
    </div>
    <div className="space-y-8">
      {sections.map((s) => (
        <div key={s.title} id={s.title}>
          <h2 className="text-base font-bold text-gray-900 dark:text-white mb-3 pb-2 border-b border-gray-200 dark:border-gray-800">
            {s.title}
          </h2>
          {renderContent(s.content)}
        </div>
      ))}
    </div>
    <p className="text-sm text-gray-500 pt-4 border-t border-gray-200 dark:border-gray-800 text-center">
      Dúvidas?{' '}
      <a href="mailto:privacidade@mybank.com.br" className="text-primary-600 hover:text-primary-700 font-medium">
        privacidade@mybank.com.br
      </a>
    </p>
  </div>
);

const Privacy = ({ embedded = false }) => {
  if (embedded) return <PrivacyContent />;

  return (
    <div className="bg-white dark:bg-gray-950 min-h-screen">
      {/* Header */}
      <div className="bg-gradient-to-b from-gray-950 to-gray-900 py-20">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-5xl font-bold text-white mb-4">Política de Privacidade</h1>
          <p className="text-gray-400">Última atualização: 1º de março de 2025</p>
        </div>
      </div>

      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="bg-primary-50 dark:bg-primary-900/20 border border-primary-200 dark:border-primary-800 rounded-2xl p-6 mb-12">
          <p className="text-primary-800 dark:text-primary-200 font-semibold mb-2">Nosso compromisso em linguagem simples:</p>
          <ul className="space-y-1 text-primary-700 dark:text-primary-300 text-sm">
            <li>✅ Seus dados financeiros são seus. Sempre.</li>
            <li>✅ Nunca vendemos seus dados para anunciantes.</li>
            <li>✅ Você pode excluir tudo a qualquer momento.</li>
            <li>✅ Não acessamos sua conta bancária. Jamais.</li>
          </ul>
        </div>

        <div className="bg-gray-50 dark:bg-gray-900 rounded-2xl p-6 mb-12 border border-gray-200 dark:border-gray-800">
          <p className="font-semibold text-gray-900 dark:text-white mb-3 text-sm">Índice</p>
          <ol className="space-y-1">
            {sections.map((s) => (
              <li key={s.title}>
                <a href={`#${s.title}`} className="text-sm text-primary-600 hover:text-primary-700 hover:underline">
                  {s.title}
                </a>
              </li>
            ))}
          </ol>
        </div>

        <div className="space-y-10">
          {sections.map((s) => (
            <div key={s.title} id={s.title}>
              <h2 className="text-xl font-bold text-gray-900 dark:text-white mb-4 pb-2 border-b border-gray-200 dark:border-gray-800">
                {s.title}
              </h2>
              {renderContent(s.content)}
            </div>
          ))}
        </div>

        <div className="mt-12 pt-8 border-t border-gray-200 dark:border-gray-800 text-center">
          <p className="text-sm text-gray-500">
            Dúvidas?{' '}
            <a href="mailto:privacidade@mybank.com.br" className="text-primary-600 hover:text-primary-700 font-medium">
              privacidade@mybank.com.br
            </a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Privacy;
